<div class="card-content"> 
    <mat-card appearance="outlined" class="card-model">
        <mat-card-header>
            <mat-card-title>
                <div class="title-card">
                    <span>Intervalo de Etiquetas</span>
                    <button mat-mini-fab color="primary" (click)="getRange()" matTooltip="Solicitar Etiquetas" >
                        <mat-icon>add</mat-icon>
                    </button>
                </div>
            </mat-card-title>
        </mat-card-header>
        <mat-card-content>
            <div class="data-content">
                <mat-grid-list cols="8" *ngFor="let item of rangeList" height="rowHeight">
                    <mat-card-tile>
                        {{item['CODECOMPANY']}}
                    </mat-card-tile>
                    <mat-card-tile>
                        {{item['CODEMKTP']}}
                    </mat-card-tile>
                    <mat-card-tile>
                        {{item['SERVICENAME']}}
                    </mat-card-tile>
                    <mat-card-tile>
                        {{item['ETQATU']}}
                    </mat-card-tile>
                    <mat-card-tile>
                        {{item['ETQINI']}}
                    </mat-card-tile>
                    <mat-card-tile>
                        {{item['ETQFIN']}}
                    </mat-card-tile>
                    <mat-card-tile>
                        {{item['SIGLA']}}
                    </mat-card-tile>
                    <mat-card-tile>
                        {{item['CODSERV']}}
                    </mat-card-tile>
                </mat-grid-list>
            </div>
        </mat-card-content>
    </mat-card>
</div>
